import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { KEYLOCKER_COMMUNICATION_EVENT_TYPE, KEYLOCKER_PIN_REQUEST_TYPES } from "models";
import { EventInfo } from "modules/AppointmentDetails/components/KeylockerCommunicationLog/components";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";
import type { KeyLockerCommunication, KeyLockerCommunicationEvent } from "models";

const getEventName = (event: KeyLockerCommunicationEvent, t: TFunction) => {
  switch (event.type) {
    case KEYLOCKER_COMMUNICATION_EVENT_TYPE.DropPINSent:
      if (event.pin_request_type !== KEYLOCKER_PIN_REQUEST_TYPES.TwoFADisabled) return t("v8_drop_pin_sent", "Drop pin sent");
      return t("v8_2fa_disabled_no_pin_sent", "2FA disabled, no PIN sent");

    case KEYLOCKER_COMMUNICATION_EVENT_TYPE.CheckInOpened:
      return t("v8_check_in_opened", "Check-in opened");

    case KEYLOCKER_COMMUNICATION_EVENT_TYPE.CheckInAnswered:
      return t("v8_check_in_answered", "Check-in answered");

    case KEYLOCKER_COMMUNICATION_EVENT_TYPE.PickUpPINSent:
      return t("v8_pick_up_pin_sent", "Pick up pin sent");

    default:
      return "";
  }
};

type CommunicationEventsProps = {
  comm: KeyLockerCommunication;
  events?: KeyLockerCommunicationEvent[];
};

export const CommunicationEvents = ({ events, comm }: CommunicationEventsProps) => {
  const { t } = useTranslation();

  if (!events?.length) return null;

  return (
    <div className="keylocker-comm-section-container">
      <div className="keylocker-comm-section-header">{t("v8_keylocker_communication_events", "Keylocker Communication Events")}</div>

      <Grid>
        {events.map((event, key) => {
          return (
            <Grid.Row key={key} className="section-rows">
              <Grid.Column width={12}>{getEventName(event, t)}</Grid.Column>

              <Grid.Column width={4} className="event-timestamp">
                {formatDate(event.created_on, DATE_FORMATS_FNS.hoursMinutes)} - {formatDate(event.created_on, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>

              <EventInfo comm={comm} event={event} />
            </Grid.Row>
          );
        })}
      </Grid>
    </div>
  );
};
